import { render, staticRenderFns } from "./cabinet.vue?vue&type=template&id=58e5bca6&"
import script from "./cabinet.vue?vue&type=script&lang=js&"
export * from "./cabinet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58e5bca6')) {
      api.createRecord('58e5bca6', component.options)
    } else {
      api.reload('58e5bca6', component.options)
    }
    module.hot.accept("./cabinet.vue?vue&type=template&id=58e5bca6&", function () {
      api.rerender('58e5bca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chkg/cabinet/cabinet.vue"
export default component.exports